import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISubscription, ISubscriptionStatus } from './types';

export interface IFeatureState {
  ready: boolean;
  statuses?: ISubscriptionStatus[];
  subscriptions?: ISubscription[];
}

export const initialState: IFeatureState = {
  ready: false,
};

export const statePropName = 'subscriptions';

const subscriptionSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    initSubscription(state) {},
    updateSubscriptionStatus(state, action: PayloadAction<ISubscriptionStatus[]>) {
      state.statuses = action.payload;
      state.ready = true;
    },
    updateSubscriptions(state, action: PayloadAction<ISubscription[]>) {
      state.subscriptions = action.payload;
    },
  },
});

export const SubscriptionActions = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
